import MojitoModules from 'mojito/modules';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

const SelectionButtonTypes = MojitoModules.SelectionButton.types;
export function getMarketsConfigs() {
    return {
        custom: {
            [PALETTE_IDS.MARKETS]: {
                GoalScorerMarketContent: {
                    playerNameHeader: {
                        style: {
                            whiteSpace: 'normal',
                        },
                        truncate: false,
                    },
                    teamNameHeader: {
                        truncate: false,
                        container: {
                            display: 'none',
                        },
                    },
                },
                GameLineMarketContent: {
                    selectionNameDisplay: {
                        TOTAL: SelectionButtonTypes.NAME_DISPLAY.SHOW,
                        _mobile_TOTAL: SelectionButtonTypes.NAME_DISPLAY.SHOW_SHORT,
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.MARKETS]: {
                MARKETS_CONTAINER_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND2,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                MARKETS_CONTAINER_HEADER_BET_BUILDER_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                MARKETS_CONTAINER_HEADER_CASHOUT_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                MARKETS_CORRECT_SCORE_NUMBER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
            },
        },
    };
}
